import React from 'react'

import { useOrganization } from '@src/Application/Interfaces/Hooks/useOrganization/useOrganization'

const RADIAN = Math.PI / 180

type Props = {
    cx: number
    cy: number
    midAngle: number
    innerRadius: number
    outerRadius: number
    percent: number
    index: number
}

export const CustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }: Props): JSX.Element => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)

    const { theme } = useOrganization()
    const fillColor = theme.color.white

    return (
        <text x={x} y={y} fill={fillColor} textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    )
}
